// eslint-disable-next-line import/no-extraneous-dependencies
import { InterlinkingFooter as CrossInterlinkingFooter } from '@digital-retail/interlinking-footer';
import PropTypes from 'prop-types';

const InterlinkingFooter = ({ isEnabled, title, groups }) => {
  if (!isEnabled) {
    return null;
  }
  return (
    <div className="interlinking-footer-container" data-testid="interlinking-footer">
      <CrossInterlinkingFooter title={title} groups={groups} />
    </div>
  );
};

InterlinkingFooter.defaultProps = {
  isEnabled: false,
  title: '',
  groups: [],
};

InterlinkingFooter.propTypes = {
  isEnabled: PropTypes.bool,
  title: PropTypes.string,
  groups: PropTypes.array,
};

export { InterlinkingFooter };
